import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  genericUnitField,
  ghgCategoryField,
  naicsCodeField,
  eeioModelKindField,
} from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { locationCountryField } from './common/locationFields';
import { currencyQuantityField } from './common/expenditureFields';

export const ceeEeioScope1Metadata = {
  displayName: msg({
    message: 'CEE EEIO Scope 1',
    context: 'Activity data schema name for CEE EEIO Scope 1',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    country: locationCountryField,
    eeio_model_kind: eeioModelKindField,
    naics_code: naicsCodeField,
    quantity: currencyQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
